module.exports = __webpack_public_path__ + "5ad9ff43206e19ddae0615022fc61cb5.jpg";